/* QubCommon Methods */
import { calculate } from "qubCommon/helperMethods/dateHelper";
import {
  wijmoAggregateColumns,
  wijmoCurrencyFormat,
  wijmoDateFormat,
} from "qubCommon/wijmoHelpers/columnMethods";
import { formatRequestObject } from "qubCommon/helperMethods/formatRequest";

/* Imports for Modal */
import { useModal, ModalImages, ModalButtons } from "context/modalContext";

/* API Calls */
import { authorizedGenApiCall } from "api/genApiCalls";

/* React, Redux, React-Hook-Forms */
import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

/* Wijmo Imports */
import { CollectionView, PropertyGroupDescription } from "@grapecity/wijmo";
import { FlexGridXlsxConverter } from "@grapecity/wijmo.grid.xlsx";
import "./index.css";

const useAppointments = () => {
  /* react-hook forms */

  const { filterKey } = useParams();
  const form = useForm();
  const { reset, handleSubmit, formState } = form;
  const { isDirty } = formState;

  /* redux */
  const [gridData, setGridData] = useState(null);
  const [explParams, setExplParams] = useState([]);

  /* Refs */
  const gridRef = useRef();
  const toolbarRef = useRef();

  /* navigate */
  const navigate = useNavigate();

  const { openModal } = useModal();

  const gridInitialized = (flex) => {
    gridRef.current = flex;
    flex.selectionMode = "Row";

    flex.hostElement.addEventListener("dblclick", async (e) => {
      const ht = flex.hitTest(e.pageX, e.pageY);
      const view = ht?.grid?.collectionView;
      const currentItem = view?.currentItem;
      console.log(currentItem);
      if (currentItem && ht.cellType === 1) {
        navigate(`/order-view/${currentItem?.OrderId}`);
      }
    });

    flex.hostElement.addEventListener("keydown", (e) => {
      const view = flex.collectionView;
      const currentItem = view.currentItem;
      if (e.code === "Enter" && view.currentItem) {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/order-view/${currentItem?.ID}`);
        /* Runs handle select */
      }
    });
    // console.log("mpika init");

    flex.itemFormatter = (panel, r, c, cell) => {
      /* html + css for rowHeaders A/A */
      if (panel.cellType === 3) {
        cell.innerHTML = `<div class='row-header'> ${
          panel.rows[r]?.index + 1
        }</div>`;
      }

      // if (panel.rows[r]?.dataItem?.RecordMsg) {
      //   panel.rows[r].cssClass = "warning-message";
      // }
      /* date format */
      wijmoCurrencyFormat(panel, r, c, cell, [
        "shipping_costs",
        "payment_costs",
        "other_costs",
        "total_payment",
      ]);
      wijmoDateFormat(panel, r, c, cell, "order_date", true, {
        d: 0,
        m: 1,
        y: 2,
        format: "dd/MM/yyyy",
      });
      wijmoDateFormat(panel, r, c, cell, "created_on", true, {
        d: 0,
        m: 1,
        y: 2,
        format: "dd/MM/yyyy",
      });
    };
    // flex.columnHeaders.rows[0].visible = false;
  };

  const onSubmit = async (data) => {
    reset(data);
    const res = await fetchData(data);
    let helpData = new CollectionView(res);
    setGridData(helpData);
    if (!helpData?.itemCount)
      openModal({
        title: "ΣΦΑΛΜΑ",
        message: `Δεν βρέθηκαν Εγγραφές`,
        imageType: ModalImages.Info,
        buttons: ModalButtons.OK,
        defaultButton: ModalButtons.OK,
        callback: () => {},
      });
  };

  const excelHandleClick = () => {
    FlexGridXlsxConverter.saveAsync(
      gridRef.current,
      {
        includeColumnHeaders: true,
        includeStyles: false,
      },
      "FlexGrid.xlsx"
    );
  };

  const fetchData = async (data) => {
    const formValues = formatRequestObject(data);

    const res = await authorizedGenApiCall({
      dataKey: "eShop-Orders-Expl",
      parameters: [...formValues],
    });
    try {
      const parsedData = JSON.parse(res?.data);
      return parsedData;
    } catch {
      console.log(res, "parsing-error");
    }
  };

  const createEpge = async (data) => {};

  const today = format(new Date(), "yyyy-MM-dd");
  const dateFrom = today + " 00:00";
  const dateTo = today + " 23:59";

  useEffect(() => {
    async function fetchParams() {
      const res = await authorizedGenApiCall({
        dataKey: "eShop-Orders-ExplParams",
      });
      try {
        const parsedData = JSON.parse(res?.data);
        setExplParams(parsedData);
        console.log(parsedData);
      } catch {
        console.log(res, "parsing-error");
      }
    }
    fetchParams();
  }, []);

  useEffect(() => {
    if (isDirty || filterKey) setGridData({ items: [] });
  }, [isDirty, filterKey]);

  return {
    gridInitialized,
    handleSubmit,
    toolbarRef,
    gridRef,
    onSubmit,
    excelHandleClick,
    fetchData,
    createEpge,
    form,
    isDirty,
    gridData,
    explParams,
    filterKey,
  };
};

export default useAppointments;
